const SUBSCRIPT_MAP = {
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "ₙ": "n",
  "ₓ": "x",
};

const SUPERSCRIPT_MAP = {
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "⁻": "-",
  "⁺": "+",
  "⁼": "=",
  "ⁿ": "n",
  "ⁱ": "i",
};

// Math and typographic symbols that Helvetica (WinAnsi) cannot render.
// Any unmapped character in this range corrupts the entire text run in jsPDF,
// so every symbol that shows up in generated content must resolve to ASCII.
const SYMBOL_MAP = {
  "\u2212": "-", // minus sign
  "\u2044": "/", // fraction slash
  "\u2215": "/", // division slash
  "\u2217": "*", // asterisk operator
  "\u22C5": "*", // dot operator
  "\u2219": "*", // bullet operator
  "\u2264": "<=",
  "\u2265": ">=",
  "\u2266": "<=",
  "\u2267": ">=",
  "\u2260": "!=",
  "\u2248": "~=",
  "\u2261": "=",
  "\u221A": "sqrt",
  "\u221E": "infinity",
  "\u2205": "empty set",
  "\u2208": " in ",
  "\u2209": " not in ",
  "\u2211": "sum",
  "\u220F": "product",
  "\u222B": "integral",
  "\u2202": "d",
  "\u2207": "grad",
  "\u2200": "for all ",
  "\u2203": "there exists ",
  "\u2234": "therefore ",
  "\u2235": "because ",
  "\u2245": "~=",
  "\u2262": "!=",
  "\u2213": "-/+",
  "\u00BD": "1/2",
  "\u00BC": "1/4",
  "\u00BE": "3/4",
  "\u2153": "1/3",
  "\u2154": "2/3",
  // Greek letters commonly used in maths/science content.
  "\u03B1": "alpha",
  "\u03B2": "beta",
  "\u03B3": "gamma",
  "\u03B4": "delta",
  "\u0394": "Delta",
  "\u03B5": "epsilon",
  "\u03B8": "theta",
  "\u03BB": "lambda",
  "\u03BC": "mu",
  "\u03C0": "pi",
  "\u03A0": "Pi",
  "\u03C1": "rho",
  "\u03C3": "sigma",
  "\u03A3": "Sigma",
  "\u03C4": "tau",
  "\u03C6": "phi",
  "\u03A6": "Phi",
  "\u03C9": "omega",
  "\u03A9": "Omega",
};

function replaceWinAnsiUnsafeChars(text) {
  return text
    .replace(/[\u2018\u2019\u201A\u2032]/g, "'")
    .replace(/[\u201C\u201D\u201E\u2033]/g, '"')
    .replace(/\u2013/g, "-")
    .replace(/\u2014/g, " - ")
    .replace(/\u2026/g, "...")
    .replace(/\u2022/g, "-")
    .replace(/\u00A0/g, " ");
}

function replaceMathSymbols(text) {
  let result = text.replace(/[\u2192\u21A6\u27F6]/g, "->");
  result = result.replace(/[\u2190\u27F5]/g, "<-");
  result = result.replace(/[\u2194\u27F7]/g, "<->");
  result = result.replace(/[\u21D2\u27F9]/g, "=>");
  result = result.replace(/[\u21D0\u27F8]/g, "<=");
  result = result.replace(/[\u21D4\u27FA]/g, "<=>");

  result = result.replace(/[₀-₉₊₋₌ₙₓ]/g, (char) => SUBSCRIPT_MAP[char] ?? char);
  result = result.replace(/[⁰¹²³⁴⁵⁶⁷⁸⁹⁻⁺⁼ⁿⁱ]+/g, (run) =>
    `^${[...run].map((char) => SUPERSCRIPT_MAP[char] ?? char).join("")}`,
  );

  result = result.replace(/[^\u0000-\u00FF]/g, (char) => SYMBOL_MAP[char] ?? "");
  return result;
}

function normalizeLine(line) {
  return line.replace(/[^\S\n]+/g, " ").trim();
}

export function normalizePdfText(value) {
  if (value == null) {
    return "";
  }

  let text = typeof value === "string" ? value : String(value);

  text = replaceWinAnsiUnsafeChars(text);
  text = replaceMathSymbols(text);

  return text
    .split("\n")
    .map(normalizeLine)
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
